"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineHeight = exports.fontWeight = exports.fontSize = exports.rootFontSize = exports.font = void 0;
var font = {
  graphik: "'Graphik LCG Web'",
  gtWalsheimPro: "'GT Walsheim Pro'",
  primary: "'Graphik LCG Web', 'Helvetica Neue', Arial, Helvetica, sans-serif",
  secondary: "'GT Walsheim Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif"
};
exports.font = font;
var rootFontSize = '13px'; // rem based on rootFontSize

exports.rootFontSize = rootFontSize;
var fontSize = {
  xtiny: '0.6153846153846154rem',
  // 8px
  tiny: '0.7692307692307693rem',
  // 10px
  xsmall: '0.8461538461538461rem',
  // 11px
  small: '0.9230769230769231rem',
  // 12px
  base: '1rem',
  large: '1.0769230769230769rem',
  // 14px
  xlarge: '1.1538461538461537rem',
  // 15px
  x2large: '1.2307692307692308rem',
  // 16px
  x3large: '1.3846153846153846rem',
  // 18px
  x4large: '1.5384615384615385rem',
  // 20px
  x5large: '1.8461538461538463rem',
  // 24px
  x6large: '2.4615384615384617rem',
  // 32px
  x7large: '2.769230769230769rem',
  // 36px
  x8large: '3.076923076923077rem',
  // 40px
  x9large: '3.230769230769231rem' // 42px

};
exports.fontSize = fontSize;
var fontWeight = {
  thin: 100,
  extralight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
};
exports.fontWeight = fontWeight;
var lineHeight = {
  // relative line heights
  leading1: '.75rem',
  leading2: '1rem',
  base: '1rem',
  leading3: '1.25rem',
  leading4: '1.5rem',
  leading5: '1.75rem',
  leading6: '2rem',
  leading7: '2.25rem',
  leading8: '2.5rem',
  // fixed line heights
  leadingNone: '1',
  leadingTight: '1.2',
  leadingXSnug: '1.3',
  leadingSnug: '1.4',
  leadingNormal: '1.5',
  leadingRelaxed: '1.625',
  leadingLoose: '2'
};
exports.lineHeight = lineHeight;
//# sourceMappingURL=typography.js.map